export var DocxParserEnum;
(function(DocxParserEnum) {
    DocxParserEnum["Libre"] = "libre";
    DocxParserEnum["Default"] = "default";
})(DocxParserEnum || (DocxParserEnum = {}));
export var DocumentBuilderActionTypeEnum;
(function(DocumentBuilderActionTypeEnum) {
    DocumentBuilderActionTypeEnum["SET_HTML"] = "SET_HTML";
    DocumentBuilderActionTypeEnum["SET_IS_LOADING"] = "SET_IS_LOADING";
    DocumentBuilderActionTypeEnum["SET_IS_SUBMITTING"] = "SET_IS_SUBMITTING";
    DocumentBuilderActionTypeEnum["SET_ERROR"] = "SET_ERROR";
    DocumentBuilderActionTypeEnum["INIT"] = "INIT";
    DocumentBuilderActionTypeEnum["SET_STATE"] = "SET_STATE";
    DocumentBuilderActionTypeEnum["SET_VIEW"] = "SET_VIEW";
})(DocumentBuilderActionTypeEnum || (DocumentBuilderActionTypeEnum = {}));
